import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Uprawnienie',
  type: 'object',
  properties: {
    roleId: {
      type: 'number',
      fieldRequired: true
    },
    permissionId: {
      type: 'number',
      title: 'Uprawnienie',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
